var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtmlIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 75,
    viewBox: "0 0 67 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_352)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3133 67.0767L0.33725 0H66.0376L60.0616 67.0405L33.1331 74.5015",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1875 68.7971V5.50525H60.0435L54.9186 62.7305",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5429 13.7087H33.1875V21.9303H21.5613L22.3219 30.3511H33.1875V38.5546H14.7885M15.1506 42.6835H23.4085L23.988 49.2572L33.1875 51.7201V60.3039L16.3096 55.5955",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7595 13.7087H33.1512V21.9303H52.999M52.2565 30.3511H33.1512V38.5728H43.2924L42.3326 49.2572L33.1512 51.7201V60.2676L49.9928 55.5955",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.33725,
    width: 65.7004,
    height: 74.5015,
    style: {
      mixBlendMode: "saturation"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.7004,
    height: 74.5015,
    fill: "white",
    transform: "translate(0.33725)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlIcon);
export default __webpack_public_path__ + "static/media/html-icon.f35ad4796feea9cd161f1ca0c702c2d9.svg";
export { ForwardRef as ReactComponent };